import { Navigate } from "react-router-dom"
import { loginPath, contactsPath } from "~/common/paths"
import { useViewerMaybe } from "../auth/use-viewer"

export const RootScreen = () => {
  const { viewer, result } = useViewerMaybe()

  if (result.loading) {
    return <div data-testid="root-screen">Loading…</div>
  } else {
    if (viewer) {
      return <Navigate to={contactsPath({})} replace />
    } else {
      return <Navigate to={loginPath({})} replace />
    }
  }
}
